export default "__VITE_ASSET__DX5vqQ80__"